// extracted by mini-css-extract-plugin
export default {"modal":"JP-z","modalOverlay":"KP-z","outfitHeading":"LP-z"};